import { CreatePhoneNumberInputDto } from '@starsoft/common/dto';
import { UserPhoneNumber } from '@starsoft/common/models';
import { AxiosInstance, AxiosResponse } from 'axios';

export async function fetchCreatePhoneNumber(
  data: CreatePhoneNumberInputDto,
  axiosInstance: AxiosInstance,
): Promise<UserPhoneNumber> {
  const response: AxiosResponse<UserPhoneNumber> =
    await axiosInstance.post<UserPhoneNumber>('/user-phone-numbers', data);

  return response.data;
}
